<template>
  <div class="content" v-if="data">
    <div class="flex-line" style="position: relative">
      <div class="title1">供应商累计交易榜</div>
      <div
        style="position: absolute; right: 0; color: #697c94; font-size: 50px"
      >
        单位 : 万元
      </div>
    </div>
    <shop-item v-for="item in list" :key="item.idx" :data="item"></shop-item>
  </div>
</template>

<script>
import ShopItem from "../common/shopItem.vue";
const colors = ["#2fafac", "#F18B4D", "#6497E6", "#697c94"];
export default {
  data() {
    return { curIdx: 0 };
  },
  components: { ShopItem },
  props: {
    data: {
      type: Array,
      required: true,
    },
  },
  computed: {
    list() {
      return this.data[this.curIdx];
    },
  },
  watch: {},
  mounted() {
    setInterval(() => {
      this.changeIdx();
    }, 3000);
  },
  methods: {
    changeIdx() {
      this.curIdx++;
      if (this.curIdx >= 3) {
        this.curIdx = 0;
      }
      var max = Math.ceil(this.list[0].value / 100) * 100;
      this.list.forEach((item, idx) => {
        item.idx = idx + 1;
        item.color =
          colors.length > idx ? colors[idx] : colors[colors.length - 1];
        item.max = max;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.content {
  color: #244b66;
  line-height: 1;
}
.title1 {
  font-size: 75px;
  margin-bottom: 20px;
}
</style>
